import { BlockComponentFactory } from '../BlockFactory'
import InputNumber from 'antd/lib/input-number'
import { NumberInputBlockProps } from './block-props.types'
import { LabelBlock } from './LabelBlock'
import { LABEL_FONT_STYLE } from '../../constants'
import commonClasses from './common.module.less'
import { useBlockListeners } from '../BlockHooks'
import { useBlockEngine } from '../BlockEngineContext'
import { toCSSSize } from './block-utils'

export const NumberInputBlockComponent =
    BlockComponentFactory.createBlockComponent<NumberInputBlockProps>(props => {
        const {
            label,
            placeholder,
            infoText,
            width,
            value,
            min,
            max,
            required = false,
            visibility = 'visible',
            disabled = false,
            style,
        } = props

        const isEditable = useBlockEngine().blockEngine.getEditableSignal().value

        const [onChangeListener] = useBlockListeners<(value: number | null) => void>('onChange')

        const containerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: toCSSSize(width) ?? 'auto',
        }

        return (
            <div style={containerStyle}>
                <LabelBlock
                    label={label}
                    required={required}
                    infoText={infoText}
                    labelStyle={LABEL_FONT_STYLE}
                />
                <InputNumber
                    className={commonClasses['width-100']}
                    placeholder={placeholder}
                    value={value}
                    min={min}
                    max={max}
                    required={required}
                    disabled={!isEditable || disabled}
                    onChange={onChangeListener?.value}
                />
            </div>
        )
    })
